export default "__VITE_ASSET__By0kjbgR__"